/** Mesma regra de match da busca: várias palavras → todas no título; uma → prefixo. */
export function matchesSearchTitle(titleLower, searchWords) {
  if (!titleLower || searchWords.length === 0) return false;
  if (searchWords.length > 1) {
    return searchWords.every((word) => titleLower.includes(word));
  }
  const titleWords = titleLower.split(' ').filter(Boolean);
  return titleWords.some((word) => word.startsWith(searchWords[0]));
}

export function parseSearchWords(term) {
  return (term || '').trim().toLowerCase().split(' ').filter(Boolean);
}
